import React, { useState } from 'react';
import classNames from 'classnames';
import { Checkbox } from 'components/inputs/Checkbox';
import { BooleanMatch } from '@decisions/server/DecisionsFramework/Design/Page/Filters';
import { IEditorProps } from '../Editor';
import { EditorLabel } from '../EditorLabel';
import { useScopeHandlers } from './hooks/useScopeHandlers';
import { PersonalizationScopeSelector } from './PersonalizationScopeSelector';
import './BooleanDataFilterEditor.less';

export interface IBooleanDataFilterEditorProps extends IEditorProps {}

const getClassName = () => classNames('dp-boolean-filter-editor');

/**
 * Editor for a boolean (personalization) data-filter editor.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function BooleanDataFilterEditor({ child, path, onChange, hideInputLabel }: IBooleanDataFilterEditorProps) {
  const [value, setValue] = useState(child.Value.OutputValue as BooleanMatch);
  const { personalization } = useScopeHandlers({ value, path, setValue, onChange });

  const onTrueChange = () => {
    const newValue = { ...value, IncludeTrues: !value.IncludeTrues };
    setValue(newValue);
    onChange(newValue, path);
  };

  const onFalseChange = () => {
    const newValue = { ...value, IncludeFalses: !value.IncludeFalses };
    setValue(newValue);
    onChange(newValue, path);
  };

  // really need these?
  // const onNullChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setValue({...value, IncludeNulls: !value.IncludeNulls})
  // }

  return (
    <EditorLabel editor={child} path={path} hideInputLabel={hideInputLabel} doNotWrap>
      <div className={getClassName()}>
        <Checkbox
          id="true"
          className="dp-boolean-filter-editor__checkbox"
          label="Include True"
          checked={value.IncludeTrues}
          onChange={onTrueChange}
        />
        <Checkbox
          id="false"
          className="dp-boolean-filter-editor__checkbox"
          label="Include False"
          checked={value.IncludeFalses}
          onChange={onFalseChange}
        />
        <PersonalizationScopeSelector {...personalization} />
      </div>
    </EditorLabel>
  );
}
